import firebaseApp from 'firebase/app';
import 'firebase/messaging';

let token;

const config = {
  apiKey: "AIzaSyAhRSR3tFymU5e2sIdtJWxa2AkXFVBVjZI",
  authDomain: "ubshop-vendor.firebaseapp.com",
  databaseURL: "https://ubshop-vendor.firebaseio.com",
  projectId: "ubshop-vendor",
  storageBucket: "ubshop-vendor.appspot.com",
  messagingSenderId: "961224370514",
};

export const initializeFirebase = () => {
  firebaseApp.initializeApp(config);
};

export const askForPermissioToReceiveNotifications = async () => {
  if (token) { return token; }
  try {
    const messaging = firebaseApp.messaging();
    await messaging.usePublicVapidKey('BKSW0yRzlE3a6IvjQGPaBK-7ZMXI6TE0HTlGXkQIyMmt50eqEH5nsdjhbuO1lESPNXhl_FfCNs0-d7UHatUAUpg');
    await messaging.requestPermission();
    token = await messaging.getToken();

    return token;
  } catch (error) {
    console.error(error);
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/push-notification.js